// extracted by mini-css-extract-plugin
export default {"CurrencySelector":"CurrencySelector_CurrencySelector__eeRG3"};